import { createSelector } from "reselect"

const getRolesStandard = (state) => state.project.rolesStandard

const getRolesAdded = (state) =>
  state.project.statuses[state.project.statusCurrent].rolesAdded
    ? state.project.statuses[state.project.statusCurrent].rolesAdded
    : []

const getRolesToPersons = (state) =>
  state.project.statuses[state.project.statusCurrent].rolesToPersons
    ? state.project.statuses[state.project.statusCurrent].rolesToPersons
    : []

const getOptionsRoles = createSelector(
  [getRolesStandard, getRolesAdded, getRolesToPersons],
  (rolesStandard, rolesAdded, rolesToPersons) => {
    let optionsRoles = [...rolesStandard, ...rolesAdded]
    let rolesAssigned = rolesToPersons.map((el) => el.rId)

    // filter out all roles that have already been assigned
    optionsRoles = optionsRoles.filter(
      (optionRole) =>
        !(rolesAssigned.indexOf(optionRole.value) > -1) ||
        optionRole.value === "memberTeam" ||
        optionRole.value === "memberStC"
    )

    return optionsRoles
  }
)

export default getOptionsRoles
